export const INVITED_STATUS_HOURS_THRESHOLD =
  process.env.REACT_APP_INVITED_STATUS_HOURS_THRESHOLD;
